import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { customFetch, fetchCurrentUserData } from "@/util/customFetch";

export async function getRegionsQuery(query, headers) {
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/regions/query?'
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getRegionsTreeQuery(query, headers) {
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/regions/tree/get?'
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getRegionsTreeQueryForUserManagement(query, headers) {
  let url = BACKEND_API_PLACEHOLDER + "/api/v1/regions/tree/user_management/get?"
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getRegionsTreeUserQuery(query, headers) {
  let url = BACKEND_API_PLACEHOLDER + '/api/v1/regions/tree/user/get?'
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
      if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
    }
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getRegionSubscriptionByUser(user_id, headers) {
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/regions/subscribers/read/user?user_id=${user_id}`
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getSiteRelocationPrompt(site_id, old_region_id, new_region_id, headers) {
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/regions/subscribers/site_relocation_prompt?site_id=${site_id}&old_region_id=${old_region_id}&new_region_id=${new_region_id}`
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(url, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
}

export async function getAllRegions() {
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/regions/`, 'GET')
}

export async function createNewRegion(data, headers) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    console.log(JSON.stringify(data))
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/regions`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    })
    .then(res => res.json()
        .then(data => { return data })
    )
}

export async function updateRegionSubscribers(data, headers) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    console.log(JSON.stringify(data))
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/regions/subscribers/update`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    })
    .then(res => res.json()
        .then(data => { return data })
    )
}

export async function batchUpdateRegionSubscribers(data, headers) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    console.log(JSON.stringify(data))
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/regions/subscribers/batch_update`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    })
    .then(res => res.json()
        .then(data => { return data })
    )
}

export async function updateRegion(data, headers) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/regions`, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify(data)
    })
        .then(res => res.json()
            .then(data => { return data })
        )
}

export async function getAllRegionsFilteredByUserID(user_id){
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/regions/${user_id}`, 'GET')
}

export async function getAllSites(){
    return customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/site/`, 'GET')
}